export default __webpack_public_path__ + "static/media/task3update.908f77b5.gif";